'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwImage = require('../../components/cwimage/CwImage');

var _CwImage2 = _interopRequireDefault(_CwImage);

var _CwUploader = require('./CwUploader.scss');

var _CwUploader2 = _interopRequireDefault(_CwUploader);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _IconPath = require('../../utils/IconPath');

var _IconPath2 = _interopRequireDefault(_IconPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwUploader = function (_Component) {
  (0, _inherits3.default)(CwUploader, _Component);

  function CwUploader() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CwUploader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CwUploader.__proto__ || (0, _getPrototypeOf2.default)(CwUploader)).call.apply(_ref, [this].concat(args))), _this), _this.getValues = function () {
      if (!_this.props.value) {
        return null;
      }

      return _this.props.value.map(function (item, index) {
        var onClose = function onClose() {
          // copy existing array
          var newValue = _this.props.value.slice(0);
          // remove from index
          newValue.splice(index, 1);

          _this.props.onChange(newValue);
        };

        return _react2.default.createElement(
          'div',
          { key: item.name + index, className: (0, _classnames2.default)(_CwUploader2.default.item, _CwUploader2.default.screenshotItem) },
          _this.props.getItemPreview(item),
          _react2.default.createElement(
            'div',
            { className: _CwUploader2.default.text },
            item.name
          ),
          _react2.default.createElement(_CwImage2.default, { className: _CwUploader2.default.closeIcon, src: _this.props.closeIcon, onClick: onClose })
        );
      });
    }, _this.getUploader = function () {
      if (!_this.props.multiple && _this.props.value && _this.props.value.length > 0) {
        // do not render uploader if only allowing 1 item and item is present
        // this prevents you from adding more items without removing current item
        return null;
      }

      var uploader = _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_CwUploader2.default.item, _CwUploader2.default.uploadItem, (0, _defineProperty3.default)({}, _CwUploader2.default.itemDisabled, _this.props.disabled)), onClick: _this.props.onUploadClicked },
        _react2.default.createElement(_CwImage2.default, {
          className: _CwUploader2.default.uploadIcon,
          src: _this.props.uploadIcon
        }),
        _react2.default.createElement(
          'div',
          { className: _CwUploader2.default.text },
          _this.props.uploadText
        )
      );

      return _this.props.customizeUploader(uploader);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CwUploader, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { 'data-cwid': this.props.cwId, className: (0, _classnames2.default)(_CwUploader2.default.wrap, (0, _defineProperty3.default)({}, _CwUploader2.default.invalid, this.props.invalid)) },
        this.getValues(),
        this.getUploader()
      );
    }
  }]);
  return CwUploader;
}(_react.Component);

CwUploader.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes2.default.string,
  value: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    name: _propTypes2.default.string
  })),
  onChange: _propTypes2.default.func.isRequired,
  /**
   * Allows you to customize the uploader component
   */
  customizeUploader: _propTypes2.default.func.isRequired,
  /**
   * Component to render as upload item preview
   */
  getItemPreview: _propTypes2.default.func.isRequired,
  disabled: _propTypes2.default.bool,
  uploadIcon: _propTypes2.default.string,
  closeIcon: _propTypes2.default.string,
  uploadText: _propTypes2.default.string,
  /**
   * Allows multiple item uploads if true
   */
  multiple: _propTypes2.default.bool,
  onUploadClicked: _propTypes2.default.func,
  /**
   * Used to control if field is valid
   */
  invalid: _propTypes2.default.bool
};

CwUploader.defaultProps = {
  uploadIcon: _IconPath2.default.get('Action_AddNew'),
  closeIcon: _IconPath2.default.get('Action_Close')
};

exports.default = CwUploader;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwuploader/CwUploader.js
// module id = 382
// module chunks = 10